import { _auth } from '@/helpers/firebase'
import { IMPERSONATION_STORAGE_KEY, ImpersonationSession } from './types'

type FirebaseTokenPayload = {
  exp?: number
  devzappImpersonation?: boolean
}

function decodeTokenPayload(token: string): FirebaseTokenPayload | null {
  try {
    const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')))
  } catch {
    return null
  }
}

function storedImpersonationSession(): ImpersonationSession | null {
  try {
    return JSON.parse(localStorage.getItem(IMPERSONATION_STORAGE_KEY) || 'null')
  } catch {
    return null
  }
}

function isUsableImpersonationToken(token: string, session: ImpersonationSession) {
  const payload = decodeTokenPayload(token)
  if (!payload?.devzappImpersonation) return false
  if (session.expiresAt <= Date.now()) return false
  return !payload.exp || payload.exp * 1000 > Date.now() + 10_000
}

/**
 * Resolves the Firebase identity for normal application requests. While support
 * impersonation is active, the simulated user's token is authoritative because
 * Firebase Auth may briefly expose the actor while auth state is being restored.
 */
export async function getEffectiveFirebaseIdToken(forceRefresh = false): Promise<string> {
  const impersonation = storedImpersonationSession()
  if (impersonation) {
    const simulatedToken = impersonation.simulatedUser.accessToken || ''
    if (isUsableImpersonationToken(simulatedToken, impersonation)) return simulatedToken

    throw new Error('A sessão do usuário simulado expirou. Encerre a simulação e acesse novamente.')
  }

  await _auth.authStateReady()
  const token = await _auth.currentUser?.getIdToken(forceRefresh)
  if (!token) throw new Error('Sua sessão expirou. Entre novamente.')
  return token
}
